import * as core from "@graffer-inc/cloud-gov-core";
import { ReadonlyFileRefKeyRegistry } from "@graffer-inc/cloud-gov-core";
import {
  InternalComment,
  UserMetaInfoWithName,
} from "@graffer-inc/smart-apply";
import { ReadonlyFetchMyNumberExchanger } from "../form-model/readonly-fetch-mynumber-exchanger";

export type ApplicationHistoryType = Omit<
  core.ApplicationHistoryType,
  "modifiedBy"
> & {
  readonly internalComment?: InternalComment;
  readonly modifiedBy: UserMetaInfoWithName;
};

export class ApplicationHistory extends core.ApplicationHistory {
  public readonly internalComment?: InternalComment;
  public readonly modifiedBy: UserMetaInfoWithName;
  constructor(values: ApplicationHistoryType) {
    super(values);
    this.internalComment = values.internalComment;
    this.modifiedBy = values.modifiedBy;
  }

  formatFileURLWithRefKey(refKey: string) {
    const fileIndex = this.files.findIndex((f) => f.refKey === refKey);
    if (fileIndex === undefined) {
      return null;
    }
    return this.formatFileURLWithIndex(fileIndex);
  }

  formatFileURLWithIndex(index: number) {
    return encodeURI(
      `/files/applications/${this.applicationId}/file?index=${index}&applicationHistoryId=${this.id}`,
    );
  }

  toFileRefKeyExchanger() {
    return new ReadonlyFileRefKeyRegistry(this);
  }

  toMyNumberRefKeyExchanger() {
    return new ReadonlyFetchMyNumberExchanger(
      this.myNumbers || [],
      this.applicationId,
      this.id,
    );
  }

  static fromJSON(json: ApplicationHistoryType) {
    return new ApplicationHistory(json);
  }

  static fromJSONArray(json?: ApplicationHistoryType[]) {
    if (!json) {
      return [];
    }
    return json.map(ApplicationHistory.fromJSON);
  }
}
